import React, {useState, useEffect} from "react"

import Card from "@irati/ui/src/Layout/Card"
import {scheduledRecognitionsQuery} from "@irati/recognition/apollo/query/ScheduledRecognitions"
import {DisablePointerEventsOnScroll} from "@irati/ui/src/DisablePointerEventsOnScroll"
import {Recognition} from "@irati/types"
import RecognitionService from "@irati/recognition/services/Recognition"
import {injectIntl} from "@irati/utils/lang"
import {InjectIntlProps} from "@irati/utils/lang/injectIntl"
import EditRecognitionPopup from "@irati-web/recognition/src/components/Popup/CreateRecognition"
import ScheduledRecognitions from "./ScheduledRecognitions"

interface Props extends InjectIntlProps {}
const MyScheduledRecognition: React.FC<Props> = () => {
  const [recognitionId, setRecognitionId] = useState<string>()
  const [scheduledRecognition, setScheduledRecognition] = useState<Recognition>()
  const handleClickCard = (obj: Recognition) => {
    setRecognitionId(obj.uuid)
  }

  useEffect(() => {
    if (!recognitionId) {
      return
    }
    RecognitionService.get(recognitionId).then((scheduledRecognitionRes: Recognition) => {
      setScheduledRecognition(scheduledRecognitionRes)
    })
  }, [recognitionId])

  const resetRecognitionSelection = () => {
    setScheduledRecognition()
    setRecognitionId()
  }
  return (
    <>
      <Card tiny noBorder>
        <DisablePointerEventsOnScroll>
          <ScheduledRecognitions recognitions={{variables: scheduledRecognitionsQuery.variables}} handleClickCard={handleClickCard} />
        </DisablePointerEventsOnScroll>
      </Card>
      {scheduledRecognition && (
        <EditRecognitionPopup hasRedirectToPolls={false} onHide={resetRecognitionSelection} scheduledRecognition={scheduledRecognition} />
      )}
    </>
  )
}

export default injectIntl(MyScheduledRecognition)
